export default {
  init () {
    this.modal()
  },

  modal () {
    let body = document.querySelector('body')

    // Define a abertura do modal
    let buscaBtns = document.querySelector('#search')
    if (buscaBtns) {
      buscaBtns.onclick = function () {
        document.querySelector('#modal').style.display = 'block'
        body.classList.add('block-scroll')
      }
    }

    // Define o fechamento do modal
    let fecharBusca = document.querySelector('#close-box');
    if (fecharBusca) {
      fecharBusca.onclick = function () {
        document.querySelector('#modal').style.display = 'none'
        document.querySelector('body').classList.remove('block-scroll')
      }
    }
  }
}
